import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { closeModal } from 'reducers/modals';
// components
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button';
import MessageBox from 'components/MessageBox';
import Modal from 'components/Modal';
// utils
import cn from 'classnames';
import mixpanel from 'mixpanel-browser';

const ConfirmationModal = ({
  title,
  className,
  actionBtnLabel,
  actionBtnProps,
  cancelBtnLabel,
  cancelBtnProps,
  closeModal,
  children,
  warningMessage,
  handleConfirm,
  noBorder,
  currentUser,
}) => {
  const handleConfirmClick = () => {
    if (currentUser && currentUser.id) {
      mixpanel.track('Feature Used', {
        user_id: currentUser.id,
        feature_name: 'ConfirmationModal',
        action: 'Click Yes/Confirm',
        modal_title: title?.props?.id || 'Confirmation Modal',
        timestamp: new Date().toISOString()
      });
    }
    handleConfirm();
    closeModal();
  };

  const handleCancelClick = () => {
    if (currentUser && currentUser.id) {
      mixpanel.track('Feature Used', {
        user_id: currentUser.id,
        feature_name: 'ConfirmationModal',
        action: 'Click Cancel',
        modal_title: title?.props?.id || 'Confirmation Modal',
        timestamp: new Date().toISOString()
      });
    }
    closeModal();
  };

  return (
    <Modal title={title} className={cn({ [className]: !!className })}>
      <section className="modal-body">
        {warningMessage && (
          <MessageBox isBorderHidden={noBorder} type="alert">
            <span>{warningMessage}</span>
          </MessageBox>
        )}
        <div>{children}</div>
      </section>
      <section className="modal-footer text-right">
        <Button className="margin-right-1" onClick={handleCancelClick} {...cancelBtnProps}>{cancelBtnLabel}</Button>
        <Button {...actionBtnProps} onClick={handleConfirmClick}>{actionBtnLabel}</Button>
      </section>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  title: T.oneOfType([T.string, T.object]).isRequired,
  className: T.string,
  actionBtnLabel: T.oneOfType([T.string, T.object]),
  actionBtnProps: T.object,
  children: T.node,
  warningMessage: T.oneOfType([T.string, T.object]),
  handleConfirm: T.func.isRequired,
  closeModal: T.func.isRequired,
  noBorder: T.bool,
  cancelBtnProps: T.object,
  cancelBtnLabel: T.oneOfType([T.string, T.object]),
  currentUser: T.object,
};

ConfirmationModal.defaultProps = {
  actionBtnProps: {},
  cancelBtnProps: {},
  actionBtnLabel: <FormattedMessage id="component.modal.allGood.confirm" />,
  cancelBtnLabel: <FormattedMessage id="general.button.cancel" />,
};

export default connect(
  (state) => ({
    currentUser: state.auth.user,
  }),
  { closeModal }
)(ConfirmationModal);
